import React, { useState } from "react";
import MuiButton from "../../shares/MuiButton";
import PanelTemplate from "../../shares/PanelTemplate";
import AddIcon from "@mui/icons-material/Add";
import AdminAddMessages from "./AdminAddMessages";
import PanelFilter from "../../shares/PanelFilter";
import AdminMessageCard from "./AdminMessageCard";
import MuiPagination from "../../shares/MuiPagination";
import useFetch from "../../../context/useFetch";
import { toast } from "react-toastify";

const AdminMessages = (props) => {
  const [openAddMessageModal, setOpenAddMessageModal] = useState(false);

  const [isFilterOn, setIsFilterOn] = useState(false);
  const [nameFilter, setNameFilter] = useState(null);
  const [messageList, setMessageList] = useState({ results: [] });

  const handleAddMessgeModal = () => {
    setOpenAddMessageModal((before) => !before);
  };

  const getListOfCustomerApi = useFetch({
    trigger :true,
    method: "get",
    url: `MainNotif_Service`,
    argFunc: (res) => {
      setMessageList(res);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  // Filter
  const filterList = [
    {
      type: "textField",
      label_fa: "موضوع",
      label_en: "name",
      state: nameFilter,
    },
  ];

  const update_filter = (state, e) => {
    if (state == "name") setNameFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (nameFilter !== null) {
      setIsFilterOn(true);
      // getCitiesApi.reFetch();
    }
  };

  const reset_filter = () => {
    setNameFilter(null);
    // getCitiesApi.reFetch();
  };

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setMessageList({ results: [] });

    // getCitiesApi.reFetch();
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="messages">
        <div className="panel-main-header">
          <span> ارسال پیام به کاربران</span>
        </div>
        <div className="add-item-container">
          <span className="text">
            برای ارسال پیام جدید روی دکمه افزودن کلیک کنید.
          </span>
          <MuiButton
            onClick={handleAddMessgeModal}
            variant="outlined"
            icon={<AddIcon />}
            color="secondary"
            text="افزودن"
          />
        </div>

        {openAddMessageModal && (
          <AdminAddMessages
            openModal={openAddMessageModal}
            setOpenModal={setOpenAddMessageModal}
              getFunc={getListOfCustomerApi}
          />
        )}

        <PanelFilter
          header="فیلتر پیام‌ها:"
          list={filterList}
          update_filter={update_filter}
          filter={filter}
          reset_filter={reset_filter}
        />

        {messageList.results.map((item, index) => {
          return [<AdminMessageCard notif={item} />];
        })}

        {/* <AdminMessageCard /> */}

        <MuiPagination
          onChange={onChangePage}
          count={Math.ceil(
            paginationPageInfo.count / paginationPageInfo.pageSize
          )}
        />
      </PanelTemplate>
    </>
  );
};

export default AdminMessages;
